import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activities: null,
    spa: null,
    viewBill: null,
};

const demoDataSlice = createSlice({
    name: 'demoDataReducer',
    initialState,
    reducers: {
        updateActivities: (state, action) => {
            state.activities = action.payload
        },
        updateSpa: (state, action) => {
            state.spa = action.payload
        },
        updateViewBill: (state, action) => {
            state.viewBill = action.payload
        },

        resetDemoData: (state, action) => {
            state = {
                activities: null,
                spa: null,
                viewBill: null,
            }
        },
    }
});


export const { updateActivities, updateSpa, updateViewBill, resetDemoData } = demoDataSlice.actions;

export default demoDataSlice.reducer;
